import * as Yup from "yup";

export const dataModel = {
  sapBatch: "",
  sapMaterial: "",
  sapQuantityEntry: "",
};

export const validationDataModel = () => {
  return Yup.object().shape({
    sapBatch: Yup.string().optional(),
    sapMaterial: Yup.string().optional(),
    sapQuantityEntry: Yup.number()
      .min(0.001, "forms.validations.required")
      .optional(),
  });
};

export const createDataModel = {
  sapBatch: "",
  sapMaterial: "",
  sapQuantityEntry: "",
};

export const createValidationDataModel = () => {
  return Yup.object().shape({
    sapBatch: Yup.string().required("forms.validations.required"),
    sapMaterial: Yup.string().required("forms.validations.required"),
    sapQuantityEntry: Yup.number()
      .min(0.001, "forms.validations.required")
      .required("forms.validations.required"),
  });
};

export const setInitialValues = (initialValues) => {
  const newValues = { ...dataModel };
  if (initialValues) {
    const items = Object.keys(newValues);
    items.forEach((item) => {
      if (initialValues[item] !== undefined && initialValues[item] !== null) {
        newValues[item] = initialValues[item];
      }
    });
    return newValues;
  }
  return dataModel;
};
